import React, { useState } from 'react';
import { connect } from 'react-redux';
import styled from 'styled-components';
import { sendTextMessage } from '../../../reducers/history/actions';
import BackIcon from '../../icons/BackIcon';

const ReturnWrapper = styled.div`
  position: absolute;
  bottom: -25px;
  right: 0;
  display: flex;
  align-items: center;
  justify-content: flex-end;
`;

const UndoButton = styled.button`
  border: none;
  background: none;
  color: ${props => props.theme.botMessageFontColor};
  border-radius: 10px;
  padding: 0px;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;

  &:hover {
    opacity: 0.8;
  }
`;

const BackButton = ({ sendTextMessage }) => {
  const [isClicked, setIsClicked] = useState(false);

  const handleBack = () => {
    if (!isClicked) {
      sendTextMessage({ text: '/sback' });
      setIsClicked(true);
    }
  };

  if (isClicked) {
    return null;
  }

  return (
    <ReturnWrapper>
      <UndoButton onClick={handleBack} title="Return to previous question">
        <BackIcon />
      </UndoButton>
    </ReturnWrapper>
  );
};

export default connect(null, { sendTextMessage })(BackButton);



// WEBPACK FOOTER //
// ./src/components/MessageHistory/BotMessage/BackButton.js